import React from 'react';

const FileTypeErrorPopup = ({ onClose }) => {

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-sm w-full text-center relative">
        <button onClick={onClose} className="absolute top-2 right-2 text-gray-500 hover:text-gray-700">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <h2 className="text-2xl font-bold mb-4 font-CirceRounded-Regular">Invalid File Type</h2>
        <p className="text-gray-600 mb-6 font-CirceRounded-Regular">
          Please upload an image with a valid file type (JPG, JPEG, or PNG).
        </p>
         <div className="flex justify-center space-x-4">
          <button
            onClick={onClose}
            className="bg-[#D50026] text-white px-6 py-2 rounded-full font-CirceRounded-Regular font-semibold"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default FileTypeErrorPopup;
